"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _propsMain = _interopRequireDefault(require("./props-main"));
var _handleDatas = _interopRequireDefault(require("./handle-datas"));
var _exportExcel = _interopRequireDefault(require("./export-excel"));
var _listEvent = _interopRequireDefault(require("./list-event"));
var _listMethods = _interopRequireDefault(require("./list-methods"));
// 导出表格

/* 初始化 */
var init = {
  computed: {
    /* 设置 搜索 参数设置 */bindSearchOptions: function bindSearchOptions() {
      return Object.assign(this.searchOptions, (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.$attrs), this.searchOptions), {}, {
        query: this.query
      }));
    },
    /* 设置 树图 参数设置 */bindTreeOptions: function bindTreeOptions() {
      return Object.assign({
        dataSource: this.treeSource
      }, this.$attrs, this.treeOptions);
    },
    /* 设置 表格 参数设置 */bindTableOptions: function bindTableOptions() {
      var options = Object.assign(this.optionInit.table, {
        dataSource: Object.assign(this.dataSource, (0, _objectSpread2.default)({
          auto: false
        }, this.dataSource))
      }, (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.$attrs), this.tableOptions), {}, {
        columns: this.columns,
        rowOperations: this.rowOperations
      }));
      return options;
    },
    tableFunction: function tableFunction() {
      return Object.assign({}, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.$listeners), {}, {
        'sort-change': this.tableSortChange,
        'pagination-change': this.paginationChange
      }));
    }
  },
  methods: {
    init: function init() {
      this.setTableRowOperations();
    }
  }
};
var _default = exports.default = [_exportExcel.default, _listEvent.default, _listMethods.default, _handleDatas.default, _propsMain.default, init];